module.exports = __webpack_public_path__ + "img/member_second_kills.56be4690.png";